import { ChevronUpIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react'

const GoToTop = () => {

    const [none, setnone] = useState(true)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.pageYOffset > 1200) {
                setnone(false)
            } else {
                setnone(true)
            }
        });

    }, []);

    return (
        <div>
            {!none && (
                <div className='fixed left-[20px] border-4 border-gray-800 dark:border-white z-30 bottom-[20px] hover:scale-90 bg-pink-400 hover:bg-pink-600 h-[55px] w-[55px] rounded-full flex items-center justify-center cursor-pointer duration-700 '
                    onClick={() => window.scrollTo(0, 0)}
                >
                    <ChevronUpIcon className='h-6 text-white' />
                </div>
            )}
        </div>
    )
}

export default GoToTop